import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import YodaProductCartridge from 'yoda-site-components/lib/components/YodaProductCartridge/YodaProductCartridge';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import getproductCartridgeSlots from '../../selectors/LabelledZone';
import selectNoSearchResults from '../../selectors/NoSearchResults';

const minimunItemToShowInLabelZone = 3;
export class LabelledZone extends SiteComponent {
    static defaultProps = {
        page: '',
        noResults: false,
        pricingConfig: {},
    };

    static propTypes = {
        noResults: PropTypes.bool,
        page: PropTypes.string,
        pricingConfig: PropTypes.object,
    };

    shouldComponentUpdate(nextProps) {
        const {
            productCartridgeSlots: { labeledZoneInfo: { header = '' } = {} } = {},
        } = this.props;
        const {
            productCartridgeSlots: { labeledZoneInfo: { header: nextPropsHeader = '' } = {} } = {},
        } = nextProps;

        /* istanbul ignore next */
        if (isEqual(header, nextPropsHeader)) {
            return false;
        }
        return true;
    }

    render() {
        const { productCartridgeSlots, page, noResults, pricingConfig } = this.props;
        if (!noResults && productCartridgeSlots && productCartridgeSlots.labeledZoneInfo) {
            const details = productCartridgeSlots.labeledZoneInfo;
            const items = details.items || [];
            /* istanbul ignore else */
            if (items.length > minimunItemToShowInLabelZone) {
                return (
                    <div data-whoami={`${page}-coreZones`}>
                        <YodaProductCartridge
                            slotId="labeledZoneInfo"
                            productCartridgeList={items}
                            cartridgeHeader={details.header || ''}
                            key={Math.random()}
                            pricingConfig={pricingConfig}
                        />
                    </div>
                );
            }
            return null;
        }
        return null;
    }
}

export const mapStateToProps = (state, selfProps) => ({
    noResults: selectNoSearchResults(state),
    productCartridgeSlots: getproductCartridgeSlots(state, selfProps),
    pricingConfig: _get(state, 'context.preferences.fpac.certona', {}),
});

export default connect(mapStateToProps)(LabelledZone);
